import { useEffect, useState, useCallback } from 'react'

import { getPerspectives } from '../services/permission'

export function usePerspectives(): SelectOption[] {
    const [perspectives, setPerspectives] = useState<SelectOption[]>([])

    const load = useCallback(async () => {
        const perspectives = await getPerspectives()
        setPerspectives(
            perspectives?.data?.map(perspective => ({
                label: perspective.name,
                value: perspective.id
            }))
        )
    }, [])

    useEffect(() => {
        load()
    }, [load])

    return perspectives
}
